const topvapewholesale = {
    id: 'topvapewholesale',
    publicSiteName: 'Top Vape Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#c54001',
            secondary: '#222222',
            color1: '#ed530a',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/topvapewholesale/favicon.ico',
        logo: '/topvapewholesale/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default topvapewholesale